import directives from './module';

directives.directive('buttonSpinner', ($timeout: ng.ITimeoutService) => ({
    restrict: 'E',
    require: '?^form',
    transclude: true,
    scope: {
        loading: '=',
        onClick: '&',
        minDelay: '=?',
        type: '@?'
    },
    template: `<button type=submit ng-class="{loading:loadingShow}" class="button button-spinner" ng-disabled="loadingShow" ng-click="click()">
    <span ng-transclude></span>
    <loader-horizontal ng-show="loadingShow"></loader-horizontal>
    </button>`,
    compile: function(this: ng.IDirective, el: ng.IAugmentedJQuery, attrs: any) {
        if (_.isString(attrs.btnClass)) {
            const classes: string[] = attrs.btnClass.split(' ');
            classes.forEach(v => el[0].querySelector('.button').classList.add(v));
        }
        return this.link;
    },
    link(scope: any, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, FormCtrl: ng.IFormController | undefined) {
        scope.minDelay = scope.minDelay || 800;
        let timeOn = 0;
        let timeoutHideSpinner: ng.IPromise<void>;

        // animation for appear loader - add padding-right and CSS3 will animate
        scope.$watch('loading', (loading: boolean) => {
            if (loading) {
                scope.loadingShow = true; // show spinner
                timeOn = _.now(); // get current date

            } else  {
                const delay = _.now() - timeOn; //show - how much time passed after spinner was started

                timeoutHideSpinner = $timeout(() => {
                    scope.loadingShow = false; // hide spinner
                }, delay > scope.minDelay ? 0 : scope.minDelay - delay); // spinner must work 800 more
            }
        });

        scope.click = () => {
            if (scope.type === 'submit' && FormCtrl) FormCtrl.$setSubmitted();
            scope.onClick();
        };

        scope.$on('$destroy', () => $timeout.cancel(timeoutHideSpinner));
    }
}));



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/loadingSpinnerDirective.ts